module.exports = __webpack_public_path__ + "img/shape-2-gold@2x.62ce37dc.png";